import React, { Component } from "react";
import getObj from "lodash/get";
import { connect } from "react-redux";
import { Form, Input, InputNumber, Card, Button, Row, Col, message, Select, Empty, Descriptions, Tabs } from "antd";
import axios from "services/axios";
import moment from "moment";
import '../../../../assets/styles/style.css';
import PhotoDocument from "../../Appraisal/PhotoComponent/PhotoDocument";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const httpFromHttps = url => url.replace('http://', 'https://');

const Option = Select.Option;
const FormItem = Form.Item;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};
const TabPane = Tabs.TabPane;

class OfferingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inquiryData: {},
      bookingId: "",
      grade: "",
      licensePlate: "",
      price: "",
      notes: "",
      photo: {},
      showModalImage: false,
      imageStyle: {backgroundImage: '', backgroundPosition: '0% 0%'}
    };
    this.setPhotoModalVisible = this.setPhotoModalVisible.bind(this);
  }

  setPhotoModalVisible = (key, photo = {}) => {
    this.setState({
      showModalImage: key,
      photo,
      imageStyle: {...this.state.imageStyle, backgroundImage: `url(${httpFromHttps(photo.imageUrl)})`  }
    });
  }

  componentDidMount = async () => {
    try {
      let { id } = this.props.match.params;
      let req = await axios.get(`/car-inquiry/${id}`);
      let reqPN = await axios.get("/user/price-negotiator-list");
      console.log(req.data)
      this.setState({
        ...req.data.inquiry,
        appraisal: req.data.appraisal,
        PN: reqPN.data.priceNegotiatorList,
        supervisor: req.data.supervisor
      });
    } catch (err) {
      console.error(err);
      message.error("Error, Can't fetch inquiry detail");
    }
  };

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        console.log(err);
      } else {
        axios
          .put(`/car-inquiry/${this.state.id}/nego`, {
            negotiationPrice: values.priceNegotiation,
            negotiationNotes: values.notesNegotiation,
            priceNegotiatorId: values.priceNegotiatorId,
          })
          .then(inquiry => {
            this.props.history.push("/home/internal-bidding/offering");
          })
          .catch(err => {
            console.log(err.message);
          });
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { appraisal, Booking, photo, supervisor } = this.state;
    return this.state.id ?(
      <Card>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Descriptions size="small" title="Car Information" column={1} bordered={true}>
              {[
                "carDetail[7]",
                "carDetail[5]",
                "carDetail[10]",
                "carDetail[11]",
                "carDetail[6]", 
                "carDetail[12]", 
                "carDetail[13]",
                "carDetail[8]", 
                "carDetail[9]", 
              ].map((field, index) => (
                <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                  {getObj(appraisal, field).value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Col>
          <Col xs={24} md={12}>
            <Descriptions size="small" title="Sales Informartion" column={1} bordered={true}>
              <Descriptions.Item label="Nama Sales">  {getObj(Booking, "SalesProfile.name")} </Descriptions.Item>
              <Descriptions.Item label="Nama Cabang"> {getObj(Booking, "SalesProfile.branch")} </Descriptions.Item>
              <Descriptions.Item label="No. Hp"> {getObj(Booking, "SalesProfile.phone")} </Descriptions.Item>
              <Descriptions.Item label="Nama SS"> {supervisor ? supervisor.name : ""} </Descriptions.Item>
            </Descriptions>

            <Descriptions size="small" title="Customer Information" column={1} bordered={true} style={{marginTop: 10}}>
              {["carDetail[0]", "carDetail[2]", "carDetail[1]"].map((field, index) => (
                <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                  {getObj(appraisal, field).value}
                </Descriptions.Item>
              ))}
            </Descriptions>

            <Descriptions size="small" title="Data Appraisal" column={1} bordered={true} style={{marginTop: 10}}>
              <Descriptions.Item label="Tanggal Appraisal"> {moment(getObj(Booking, "bookingTime")).format("YYYY-MM-DD hh:mm A")} </Descriptions.Item>
              <Descriptions.Item label="Nama Appraiser"> {getObj(Booking, "Appraiser.name")} </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>

        <Row>
          <Card title="Offering Form" style={{ marginTop: "30px" }}>
            <Form layout="vertical"  onSubmit={e => this.handleSubmit(e)}>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <FormItem label="Harga Sistem" {...formItemLayout}>
                    {getFieldDecorator("price", {
                      rules: [{ required: true, message: "Harga is required" }],
                      initialValue: this.state.price,
                    })(
                      <InputNumber
                        disabled
                        style={{ width: "100%" }}
                        formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      />,
                    )}
                  </FormItem>

                  <FormItem label="Catatan" {...formItemLayout}>
                    {getFieldDecorator("notes", { initialValue: this.state.notes })(<Input.TextArea rows={4}disabled />)}
                  </FormItem>
                </Col>
                <Col xs={24} md={12}>
                  <FormItem label="Harga Nett" {...formItemLayout}>
                    {getFieldDecorator("priceNegotiation", {
                      rules: [{ required: true, message: "Harga Nego Awal wajib diisi" }],
                    })(
                      <InputNumber
                        style={{ width: "100%" }}
                        formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      />,
                    )}
                  </FormItem>
                  <FormItem label="Nama TNT" {...formItemLayout}>
                    {getFieldDecorator("priceNegotiatorId", {
                      rules: [{ required: true, message: "Price Negotiator is required" }],
                    })(
                      <Select>
                        {this.state.PN.map(pn => {
                          return (
                            <Option key={pn.id} value={pn.id}>
                              {pn.name}
                            </Option>
                          );
                        })}
                      </Select>,
                    )}
                  </FormItem>
                  <FormItem label="Catatan" {...formItemLayout}>
                    {getFieldDecorator("notesNegotiation", {})(<Input.TextArea />)}
                  </FormItem>

                  <Button type="primary" htmlType="submit">
                    Update
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
        </Row>

        <Row>
          <Col xs={24} md={24}>
            <Card style={{ marginTop: "30px" }}>
              <Tabs defaultActiveKey="1" onChange={this.onChangeTabs}>
                <TabPane forceRender={true} tab="Photo" key="1">
                  <div id="photo-doc-print">
                    {appraisal.photoDocument ? (
                      <PhotoDocument
                        photos={appraisal.photoDocument}
                        appraisalId={appraisal.id}
                        photoModal={this.setPhotoModalVisible}
                      />
                    ) : (
                      <PhotoDocument
                        photos={appraisal.carDetail}
                        appraisalId={appraisal.id}
                        photoModal={this.setPhotoModalVisible}
                      /> 
                    )}
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="Frame" key="2">
                  <div id="photo-frame-print">
                    <PhotoDocument
                      photos={appraisal.photoFrame}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                    />
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="System Engine" key="3">
                  <div id="photo-engine-print">
                    <PhotoDocument
                      photos={appraisal.photoEngine}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                    />
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="Interior" key="4">
                  <div id="photo-interior-print">
                    <PhotoDocument
                      photos={appraisal.photoInterior}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                    />
                  </div>
                </TabPane>
                <TabPane forceRender={true} tab="Exterior" key="5">
                  <div id="photo-exterior-print">
                    <PhotoDocument
                      photos={appraisal.photoExterior}
                      appraisalId={appraisal.id}
                      photoModal={this.setPhotoModalVisible}
                    />
                  </div>
                </TabPane>
              </Tabs>
            </Card>
          </Col>
        </Row>

        <div id="imgCanvas" />

        {this.state.showModalImage && (
          <Lightbox
            mainSrc={photo.imageUrl}
            onCloseRequest={() => this.setPhotoModalVisible(false)}
          />
        )}

      </Card>
    ) : (<Empty/>) ;
  }
}

const FormOffering = Form.create()(OfferingDetail);
const mapStateToProps = ({ Auth }) => ({ Auth });

export default connect(mapStateToProps)(FormOffering);



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/Offering/OfferingDetail.js